import { useMemo } from "react"
import type { PartnerContact } from "@stockline/shared/types/crm/partner-contact"
import { PARTNER_CONTACT_TABLE } from "../../../lib/offline/resources/crm/partner-contact/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UsePartnerContactsFilter {
  partnerId?: string
  companyOwner?: boolean
  includeDeleted?: boolean
}

export function usePartnerContacts(
  filter?: UsePartnerContactsFilter
): PartnerContact[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<PartnerContact>(PARTNER_CONTACT_TABLE, {
    ...(filter?.partnerId ? { partnerId: filter.partnerId } : {}),
    ...(filter?.companyOwner !== undefined
      ? { companyOwner: filter.companyOwner }
      : {}),
    orderBy: "-updatedAt",
  })
  const includeDeleted = filter?.includeDeleted
  return useMemo(
    () => (includeDeleted ? rows : rows.filter((r) => !r.deletedAt)),
    [rows, includeDeleted]
  )
}
